import React from 'react';
import { useNavigate, useParams } from 'react-router';
import { notification } from 'antd';

import { useAppDispatch, useAppSelector } from 'store';
import {
  IInvestInfrastructuresItem,
  TInvestInfrastructuresDraftItem,
} from 'store/slices/investInfrastructures/interfaces';
import { MainLayout } from 'components/Layout/MainLayout';
import {
  loadInvestInfrastructuresItem,
  saveInvestInfrastructuresItem,
  saveInvestInfrastructuresItemAsDraft,
} from 'store/slices/investInfrastructures/actions';
import { StatusesEnum } from 'constants/status';

import { InvestInfrastructuresForm } from './components/InvestInfrastructuresForm/InvestInfrastructuresForm';
import { mapValuesToForm } from './components/InvestInfrastructuresForm/formUtils';

export const Edit = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const { item } = useAppSelector(state => state.investInfrastructures);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  React.useEffect(() => {
    dispatch(loadInvestInfrastructuresItem(id));
  }, []);

  const onFinish = (values: IInvestInfrastructuresItem) => {
    setIsLoading(true);
    dispatch(saveInvestInfrastructuresItem({ ...values, id: item.id }))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Сущность успешно изменена',
        });
        navigate('/investInfrastructures');
      })
      .catch(() => setIsLoading(false));
  };

  const onSaveDraft = (values: TInvestInfrastructuresDraftItem) => {
    setIsLoading(true);
    dispatch(saveInvestInfrastructuresItemAsDraft({ ...values, id: item.id }))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Сущность успешно изменена',
        });
        navigate('/investInfrastructures');
      })
      .catch(() => setIsLoading(false));
  };

  const cancelButtonHandler = () => {
    navigate('/investInfrastructures');
  };

  return (
    <MainLayout pageTitle='Редактирование'>
      {item?.id && String(item?.id) === id ? (
        <InvestInfrastructuresForm
          onFinish={onFinish}
          onSaveDraft={onSaveDraft}
          cancelButtonHandler={cancelButtonHandler}
          isDraft={item.status === StatusesEnum.DRAFT}
          isLoading={isLoading}
          initialValues={mapValuesToForm(item)}
        />
      ) : null}
    </MainLayout>
  );
};
